








import Vue from "vue";
import { Component } from "vue-property-decorator";
import ApiFactory from "../../api/ApiFactory";
import { PaymentFrequencyDto } from "@/api/ClientPortalApiClient";

@Component({})
export default class CbxPaymentFrequency extends Vue {
  private types: PaymentFrequencyDto[] | null = [];
  public selectedType = new PaymentFrequencyDto();

  public created() {
    this.getAvailableTypes();
  }

  public setSelected(type: PaymentFrequencyDto | undefined) {
    if (type) {
      this.selectedType = type;
    }
  }

  public typeSelected(type: PaymentFrequencyDto) {
    this.$emit("paymentFrequencySelected", type);
  }

  private getAvailableTypes() {
    const api = ApiFactory.CreateDataClient();
    api
      .paymentFrequency_IndexAll()
      .then(result => {
        if (result) {
          this.types = result;
        } else {
          this.types = [];
        }
      })
      .catch(error => {
        console.log(error);
        this.types = [];
      });
  }
}
